import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=288717f2&"
import script from "./integrations.vue?vue&type=script&lang=js&"
export * from "./integrations.vue?vue&type=script&lang=js&"
import style0 from "./integrations.vue?vue&type=style&index=0&id=288717f2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports